export default __webpack_public_path__ + "static/media/hydroxyurea.474eb323.jpg";